// frontend/src/services/eda.service.ts

import api from './api';

const BASE_URL = '/eda';

export class EdaService {

  static async listSnapshots(): Promise<any[]> {
    const response = await api.get(`${BASE_URL}/snapshots`);
    return response.data.data;
  }

  static async getSnapshot(id: number): Promise<any> {
    const response = await api.get(`${BASE_URL}/snapshot/${id}`);
    return response.data.data;
  }

  static async getSnapshotByName(datasetName: string): Promise<any> {
    const response = await api.get(`${BASE_URL}/snapshot/name/${datasetName}`);
    return response.data.data;
  }

  static async getSnapshotsByTraceId(traceId: string): Promise<any[]> {
    const response = await api.get(`${BASE_URL}/snapshot/trace/${traceId}`);
    return response.data.data;
  }
}